export const BASE_URL_WEBSITE = 'https://api.tattersallgestiondeactivos.cl'
export const BASE_URL_WEB = 'https://tattersallgestiondeactivos.cl'
export const HOST = 'https://qa-api.rematetattersallgda.com'

export const PATH = {
  AUCTION: `${HOST}/auction`,
  SESSION: `${HOST}/session`,
  GUARANTEES: `${HOST}/guarantee`,
  EMAIL: `${HOST}/email`,
  STORAGE: `${HOST}/storage`,
  REPORT: `${HOST}/report`,
  SOCKET_AUCTION: `${HOST}`,
  LOAD_INIT: `${HOST}/loadinit`,
  INTEGRATION: `${HOST}/integration`
}

export const STREAMING = {
  WEBRTC: 'wss://media.rematetattersallgda.com',
  URL: 'https://media.rematetattersallgda.com',
  RTMP: 'rtmp://rtmp.rematetattersallgda.com',
  ID_SUFFIX: 'qa',
}

export const WEB = {
  BASE: 'http://localhost:3000',
  HOME: '/',
  EXPIRED: '/expired',
  LOGIN_URL: 'https://tattersallgestiondeactivos.cl/login?rol=true',
}

export const URL_TCIT = {
  BASE: 'https://tattersallgestiondeactivos.cl',
  URL: '/login',
}
export const NAME = 'qa'
